import React, { useState } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Circle,
  color,
  Divider,
  Flex,
  Heading,
  IconButton,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Square,
  Text,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  filterActions,
  studentActions,
} from "../../../redux/actions";
import AjnaVidyaLogo from "../../../Assets/AjnaVidyaLogoNew.png";
import AjnaVidyaLogo2 from "../../../Assets/AjnaVidyaLogoNew2.png";
import hamIcon from "../../../Assets/hamIcon.png";
import search from "../../../Assets/search.png";
import plus from "../../../Assets/plus_icon.png";
import bell from "../../../Assets/bell_icon.png";
import chat from "../../../Assets/chat_icon.png";
import password from "../../../Assets/password.svg";
import logout from "../../../Assets/Logout.svg";
import company from "../../../Assets/company.png";
import profileIcon from "../../../Assets/newProfile.svg";
import { CloseIcon } from "@chakra-ui/icons";
import { recruiterActions } from "../../../redux/actions";
import { NavbarData } from "contants/contants";

export const NavbarCommon = () => {
  const [display, setChangeDisplay] = useState("none");
  const [stateActive, setStateActive] = useState(false);
  const [stateClosed, setStateClosed] = useState(false);
  const [stateDraft, setStateDraft] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const recruiter = useSelector((state) => state.recruiter);
  const [user, setUser] = useState("");
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div>
      <Box>
        {/* Container */}
        <Box
          borderBottom="1px solid #DEDEDE"
          // boxShadow={"0px 4px 18px rgba(0, 0, 0, 0.13)"}
          w="100%"
          display={["none", "none", "none", "flex", "flex"]}
          px={[0, 0, 0, 0, 2]}
          bg={"#fff"}
          position={"fixed"}
          zIndex={+1000}
          top={0}
        >
          <Box w="100%" h={20}>
            {/* Main Flex */}
            <Center>
              <Flex
                align="center"
                h="100%"
                w="100%"
                justify="start"
                margin={"0 4%"}
              >
                {/* First Half */}
                <Box>
                  <Flex align="center" gap={20}>
                    {/* Logo */}
                    <Link to={"/hiring/recruiter/active"} replace={true}>
                      <Box>
                        <Flex align="center" gap={2}>
                          <Box h={9}>
                            <img
                              style={{ height: "100%" }}
                              src={AjnaVidyaLogo}
                              alt="logo"
                            />
                          </Box>
                        </Flex>
                      </Box>
                    </Link>
                    {/* Tabs */}
                    <Box>
                      <Flex gap={35}>
                        {/* navbar links */}
                        {NavbarData.map((item) => (
                          <Link to={item.path} replace={true}>
                            <Box
                              cursor="pointer"
                              w={"fit-content"}
                              h="auto"
                              py={7}
                              pb={7}
                              borderBottom={
                                stateActive
                                  ? "2px solid #6C56FB"
                                  : "2px solid transparent"
                              }
                              color={stateActive ? "#6C56FB" : "#85808C"}
                            >
                              <Heading
                                fontSize={20}
                                fontWeight={stateActive ? "500" : "400"}
                                fontFamily={"Roboto"}
                                letterSpacing={"0.04em"}
                              >
                                {item.title}
                              </Heading>
                            </Box>
                          </Link>
                        ))}
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Center>
          </Box>
        </Box>

        {/* Mobile View */}

        <Flex
          display={["flex", "flex", "none", "none"]}
          justify="space-between"
          borderBottom={"1px solid #E4E4E4;"}
          py={2}
          w={"100%"}
          bg={"#fff"}
          position={"fixed"}
          top={0}
          zIndex={+1000}
        >
          <Flex align="center" gap={1}>
            <Circle size={10} onClick={() => setChangeDisplay("flex")}>
              <img src={hamIcon} alt="logo" />
            </Circle>
            <Circle size={8}>
              <img src={AjnaVidyaLogo2} alt="logo" />
            </Circle>
          </Flex>

          {/* Create Job Post */}

          <Flex
            bg={"#6C56FB"}
            align={"center"}
            justify={"center"}
            px={4}
            borderRadius={40}
            mr={4}
            onClick={() => {
              navigate("/hiring/recruiter/createPost");
            }}
          >
            <Text fontSize={20} mb={1} color={"#FFFFFF"}>
              +
            </Text>
            <Text fontSize={16} fontFamily={"Roboto"} color={"#FFFFFF"}>
              Job Post
            </Text>
          </Flex>
          {/* To Enable search change display attribute */}

          {/* Search */}
          <Flex gap={2} display="none">
            <Flex
              w={searchActive ? "100%" : "10"}
              border={"1px solid #DDDDDD"}
              pl={2}
              align="center"
              borderRadius={20}
            >
              <Input
                type={"search"}
                variant="unstyled"
                placeholder="Search..."
              />
              <Circle
                size={6}
                onClick={() => setSearchActive(!searchActive)}
                pos="relative"
                mr={2}
              >
                <img src={search} alt="search" />
              </Circle>
            </Flex>

            {/* <Circle border="1px solid #DDDDDD" size={10}>
              <img src={bell} alt="bell" />
            </Circle>
            <Circle border="1px solid #DDDDDD" size={10} mr={4}>
              <img src={chat} alt="chat" />
            </Circle> */}
          </Flex>
        </Flex>

        <Flex
          w="100vw"
          display={display}
          bgColor="gray.50"
          zIndex={20}
          h="100vh"
          pos="fixed"
          top="0"
          left="0"
          overflowY="auto"
          flexDir="column"
        >
          <Flex justify="flex-start">
            <IconButton
              mt={16}
              ml={2}
              aria-label="Open Menu"
              size="lg"
              icon={<CloseIcon />}
              onClick={() => setChangeDisplay("none")}
            />
          </Flex>

          <Flex flexDir="column" align="center">
            <Link to={"/hiring/recruiter/active"}>
              <Button as="a" variant="ghost" aria-label="Home" my={5} w="100%">
                Active
              </Button>
            </Link>

            <Link to="/hiring/recruiter/closed">
              <Button as="a" variant="ghost" aria-label="About" my={5} w="100%">
                Closed
              </Button>
            </Link>

            <Link to="/hiring/recruiter/draft">
              <Button
                as="a"
                variant="ghost"
                aria-label="Contact"
                my={5}
                w="100%"
              >
                Draft
              </Button>
            </Link>

            <Divider />

            <Accordion w="90%" mt={6} allowToggle>
              <AccordionItem>
                <AccordionButton
                  justifyContent="space-between"
                  bg={"transparent"}
                  border="none"
                  outline={"none"}
                >
                  <Flex align="center" gap={2}>
                    <Circle border="1px solid" size={12} overflow="hidden">
                      <img
                        src={recruiter.profilePhoto || profileIcon}
                        alt="profile"
                      />
                    </Circle>
                    <Heading fontSize={16}>{recruiter.name}</Heading>
                  </Flex>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel>
                  <Flex flexDir="column" gap={6}>
                    {/* Edit Button */}
                    <Button
                      onClick={() => navigate(`/hiring/recruiter/Editprofile`)}
                    >
                      Edit Profile
                    </Button>

                    {/* Change Password */}
                    <Flex
                      gap={2}
                      onClick={() =>
                        navigate("/hiring/recruiter/change_password")
                      }
                    >
                      <Square size={6} overflow={"hidden"}>
                        <img
                          height={"100%"}
                          width={"100%"}
                          src={password}
                          alt=""
                        />
                      </Square>
                      <Text textAlign="left">Change password</Text>
                    </Flex>

                    {/* Manage Company */}
                    <Flex
                      gap={2}
                      onClick={() => {
                        navigate(
                          `/hiring/recruiter/manageCompany/${recruiter?.companyId}`
                        );
                      }}
                    >
                      <Square size={6} overflow={"hidden"}>
                        <img
                          height={"100%"}
                          width={"100%"}
                          src={company}
                          alt=""
                        />
                      </Square>
                      <Text textAlign="left">Manage company profile </Text>
                    </Flex>
                  </Flex>
                </AccordionPanel>
                <AccordionPanel>
                  <Flex
                    gap={2}
                    onClick={() => {
                      dispatch(authActions.logout());
                    }}
                  >
                    <Square size={6}>
                      <img height={"100%"} width={"100%"} src={logout} alt="" />
                    </Square>

                    <Text>Logout</Text>
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </Flex>
        </Flex>
      </Box>
    </div>
  );
};
